<template>
  <div class="top_container">
    <Layout class="top-app-layout">
      <div class="top-app-header-space" :class="[thema=='blue'?'blue-header':'']"></div>
      <Header :class="['top-app-header',thema=='blue'?'blue-header':'']" :style="thema=='blue'?'':`background: url(${$store.state.core.top.topImg}) 100% 100%;`">
        <!-- <Header :class="['top-app-header',thema=='blue'?'blue-header':'']"
      :style="thema=='blue'?'':`background: url('/static/img/sidebar-top.png') no-repeat center;`"
      >  -->
        <!-- background: url('/static/img/sidebar-top.png') no-repeat center; -->
        <!-- <appHeader /> -->
        <appHeader />
        <!-- <div class="header-bg"> -->
        <!-- <img src="./top_bg@2x.png"> -->
        <!-- </div> -->
      </Header>
      <Content class="top-app-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </Content>
    </Layout>
  </div>

</template>

<script>
import appHeader from "./header"

function createMeta(obj) {
  var meta = document.createElement("meta")
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      meta[key] = obj[key]
    }
  }
  document.getElementsByTagName("head")[0].appendChild(meta)
}
export default {
  components: { appHeader },
  computed: {
    thema() {
      return this.$store.state.core.thema
    },
  },
  mounted() {
    this.$nextTick(() => {

      if (navigator.windowControlsOverlay) {
        if (this.thema == "blue") {
          createMeta({
            name: "theme-color",
            content: "#E2EDFB",
          })
        }
      }
      
    })
  },
}
</script>

<style lang="scss">
// 顶部布局的全局样式
body {
  overflow-x: auto !important;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #606870;
    border-radius: 10px;

    &:hover {
      background: #606870;
    }
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &.controlTitleBar {
    .top-app-header {
      flex-basis: 80px !important;
    }
    .top-app-header-space {
      height: 20px !important;
    }
  }
}

.top-app-layout {
  height: 100vh;
  overflow: hidden;
  background: transparent;
  .top-app-header-space {
    height: 0px;
  }
  .top-app-header {
    padding: 0px 30px;
    flex-basis: 70px;
    transition: all 0.3s;
    // background: url('/static/img/sidebar-top.png') no-repeat center;
    background-size: cover;
    z-index: 2;
    //   background: rgba(27, 27, 27, 0.74);
    .ivu-menu-item > i {
      // margin-right: 2px;
    }
    .user .name {
      // color: rgba(255, 255, 255, 0.7);
    }
  }
  .blue-header {
    background: rgba(226, 237, 251, 1);
  }
  .top-app-content {
    overflow: auto;
    flex: 1;
    z-index: 1;
  }
}

.top_container {
  min-width: 1200px;
  margin: 0 auto;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 1600px) {
  .top-app-header {
    // padding: 16px;
  }
}
@media screen and (max-width: 1200px) {
}
</style>
